import { Clickable, Col, Game, Row, Sidepanel, Text } from 'components';
import { endOfDay, startOfDay } from 'date-fns';
import { theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { GameItem } from './components';

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 151px;
  background-color: ${theme.FOG};
  bottom: 0;
  z-index: -1;
`;

const ComingUp = ({ data, marg }) => {
  const [filtered, setFiltered] = useState([]),
    [shownGame, setShownGame] = useState(null),
    [showGameModal, setShowGameModal] = useState(false),
    [showSeeAll, setShowSeeAll] = useState(false),
    { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState);

  useEffect(() => {
    if (!data) {
      return;
    }

    const now = new Date(),
      dayStart = startOfDay(now),
      dayEnd = endOfDay(now);

    const todaysGames = data.filter((game) => {
      return new Date(game.date) > dayStart && new Date(game.date) < dayEnd;
    });
    const liveGames = todaysGames.filter((game) => game.status === 'live');
    const upcomingGames = todaysGames.filter((game) => game.status == 'upcoming');
    const concludedGames = todaysGames.filter((game) => game.status === 'finished');

    setFiltered([...liveGames, ...upcomingGames, ...concludedGames]);
  }, [data]);

  if (!filtered?.length) return null;

  return (
    <React.Fragment>
      <Sidepanel
        title={<Row pad="24px">{t('home.todaysGames')}</Row>}
        visible={showSeeAll}
        closeModal={() => setShowSeeAll(false)}
      >
        <Col gap="8px">
          {filtered.map((x, i) => (
            <GameItem
              item={x}
              key={i}
              fullWid
              dontShowGamePage
              onClick={() => {
                setShownGame(x);
                setTimeout(() => setShowGameModal(true), 100);
              }}
            />
          ))}
        </Col>
      </Sidepanel>

      <Game ev={shownGame} visible={showGameModal} closeModal={() => setShowGameModal(null)} />

      <Col
        wid="100%"
        pad={isMobile && '0 0 17px'}
        marg={marg || (isMobile ? '16px 0 16px' : '40px 0 0')}
        pos="relative"
      >
        {isMobile && <Background />}

        <Row wid="100%">
          <Row
            between
            center
            wid="100%"
            marg={isMobile ? '0 0 8px' : '0 0 16px'}
            pad={isMobile && '0 16px'}
          >
            <Text h2>{t('home.todaysGames')}</Text>

            {!isMobile && (
              <Clickable onClick={() => setShowSeeAll(true)}>
                <Text b2 bold>
                  {t('common.seeAll')}
                </Text>
              </Clickable>
            )}
          </Row>
        </Row>

        <Row
          noFlex
          start
          scrollX={isMobile}
          wid={isMobile && '100vw'}
          gap={!isMobile && '24px'}
          hideScrollBar
        >
          {filtered.slice(0, 3).map((x, i) => (
            <Col noFlex key={i} marg={!i ? isMobile && '0 12px 0 16px' : isMobile && '0 16px 0 0'}>
              <GameItem item={x} />
            </Col>
          ))}
        </Row>
      </Col>
    </React.Fragment>
  );
};

export default ComingUp;
